import { COLOR, IMG } from "../../themes";

const ExternalIcon = ({ color = COLOR.GOLD_1, width = 12, height = 12, style = {}, className = '' }) => (
  <div
    className={className}
    style={{
      width: `${width}px`,
      height: `${height}px`,
      backgroundColor: color,
      mask: `url(${IMG['ic_external-link.svg']}) no-repeat center / contain`,
      WebkitMask: `url(${IMG['ic_external-link.svg']}) no-repeat center / contain`,
      ...style
    }}
  />
);

export default ExternalIcon;
